import o from "./index105.js";
import i from "./index159.js";
function f(t) {
  var r = i(t, "string");
  return o(r) == "symbol" ? r : r + "";
}
export {
  f as default
};
